import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieBanner.css';

const STORAGE_KEY = 'sincere_cookie_notice_acknowledged';

function CookieBanner(): React.JSX.Element | null {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const acknowledged = localStorage.getItem(STORAGE_KEY);
    if (!acknowledged) {
      setTimeout(() => setVisible(true), 800);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  const privacyPath = i18n.language === 'pt' ? '/privacy-pt' : '/privacy';

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie notice">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <p>
            {t('cookieBanner.message')}{' '}
            <Link to={privacyPath} className="cookie-banner-link">
              {t('cookieBanner.privacyPolicy')}
            </Link>
            .
          </p>
        </div>
        <button className="cookie-banner-btn" onClick={handleAccept}>
          {t('cookieBanner.accept')}
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
